import { AlertStatus } from "../types";

const STATUS_STYLES: Record<AlertStatus, { bg: string; text: string; label: string }> = {
  active: { bg: "bg-[#ECFDF3]", text: "text-[#16A34A]", label: "Active" },
  paused: { bg: "bg-[#F4F4F5]", text: "text-[#71717A]", label: "Paused" },
};

interface AlertStatusBadgeProps {
  status: AlertStatus;
}

export default function AlertStatusBadge({ status }: AlertStatusBadgeProps) {
  const styles = STATUS_STYLES[status];

  return (
    <span
      className={`inline-flex items-center rounded-full px-[10px] py-[4px] text-[12px] font-medium ${styles.bg} ${styles.text}`}
    >
      {styles.label}
    </span>
  );
}
